import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#BAB4B4",
        d: "m12.06 18.788 2.628-2.613-2.628-2.613-.839.838 1.229 1.229a5 5 0 0 1-1.713-.25 3.34 3.34 0 0 1-1.318-.798 3.6 3.6 0 0 1-.8-1.208 3.6 3.6 0 0 1-.273-1.358q0-.424.103-.85a4 4 0 0 1 .293-.815l-.888-.85a4.5 4.5 0 0 0-.529 1.21 4.832 4.832 0 0 0 .19 3.107q.36.897 1.061 1.602t1.702 1.054a6.5 6.5 0 0 0 2.057.364L11.22 17.95zm4.096-4.288q.357-.577.529-1.21a4.92 4.92 0 0 0-.182-3.116 4.6 4.6 0 0 0-1.059-1.609 4.3 4.3 0 0 0-1.707-1.046 6.4 6.4 0 0 0-2.062-.34l1.113-1.129-.838-.838-2.629 2.613 2.629 2.613.838-.838-1.244-1.244q.915 0 1.721.272.806.271 1.328.795.523.523.796 1.202.275.68.275 1.36a3.6 3.6 0 0 1-.103.85 4 4 0 0 1-.294.815zm-4.154 7a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
      })
    ], -1)
  ])))
}
export default { render: render }